var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.renewing)?_c('app-spinner',{style:({transform: 'translate(-50%, -50%) scale(0.5)'}),attrs:{"color":_vm.$vuetify.theme.primary}}):_c('v-icon',{style:({
      color: _vm.expired ? _vm.colorExpiredC : _vm.colorNotExpiredC,
      transform: 'translate(-50%, -50%)'}),on:{"click":function($event){_vm.$emit('click')}}},[_vm._v("\n      "+_vm._s(_vm.iconName)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }